/**
 * Monetization types for credits API responses.
 * Handles both old (creditInfo) and new (creditsInfo) SDK formats.
 */

export interface CreditInfo {
  credits: number;
  addonCredits: number;
}

export interface CreditsResponse {
  /** New SDK format */
  creditsInfo?: CreditInfo;
  /** Old SDK format */
  creditInfo?: CreditInfo;
}

/**
 * Extract total credits from a credits response, handling both SDK formats.
 */
export const getTotalCredits = (response: CreditsResponse): number => {
  const info = response.creditsInfo ?? response.creditInfo;
  if (!info) return 0;
  return (info.credits ?? 0) + (info.addonCredits ?? 0);
};
